export default __webpack_public_path__ + "static/media/promo-you-know-who_00.b13763b9.jpg";